
import Typography from '@mui/material/Typography';


export const TextDrugBrexipiprazole = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Brexpiprazole is used to treat the symptoms of schizophrenia (a mental illness that causes disturbed or unusual thinking, loss of interest in life, 
and strong or inappropriate emotions) in adults and children 13 years of age and older. It is also used with an antidepressant to treat depression 
when symptoms cannot be controlled by the antidepressant alone. Brexpiprazole is also used to treat agitation in people with dementia due to Alzheimer's disease 
(a brain disease that slowly destroys the memory and ability to think, learn, communicate, and handle daily activities). 
Brexpiprazole is in a class of medications called atypical antipsychotics. It works by changing the activity of certain natural substances in the brain.
<br /><br />


Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a615046.html

</Typography>

</div>

)
}